// Revised Manufacturers List v1.1 - 01/05/2026
// Keep the revision date updated to facilitate adding or amending items to the list below

const manufacturerList = [
  "1st 4 Thirst",
  "1st Choice",
  "1st Security",
  "21 Degrees",
  "2A's",
  "3 Way Electrical Services",
  "360 Vision Technology",
  "3D X-Ray",
  "3ET",
  "3G Controls",
  "3L Electrical",
  "3M Healthcare",
  "3Shape",
  "A Campbell",
  "A F Switchgear And Control Panels",
  "A Miles Shutters",
  "A&A Electrical",
  "A&A Sprinklers",
  "A&E Fire And Security",
  "A&J Gummers",
  "A&M Security",
  "A.C. Automation",
  "A.D.C. Fans",
  "A.L.P. Electrical (Maidenhead)",
  "A.O. Smith",
  "A1 Fire Protection Group",
  "A1 Flue Systems",
  "A1 Refrigeration And Air Conditioning",
  "A1S Group",
  "AA Direct",
  "AA First",
  "Aable Fortress Door Systems",
  "Aadgard A/S",
  "AAF International",
  "AAF Snyder",
  "AAI Security Systems",
  "AAON",
  "Aardee",
  "Aardvark",
  "AAW Control Systems",
  "AB Arboga Maskiner",
  "AB Electrics",
  "AB Power Systems",
  "ABAC",
  "ABAC Air Compressors",
  "Abacus",
  "Abacus Shutters",
  "ABB",
  "Abbey Air",
  "Abbey Fire",
  "Abbey Heat",
  "Abbey-Langham Lifts",
  "Abbott",
  "Abbott & Co. (Newark)",
  "Abbott Diabetics",
  "ABC Industrial Doors",
  "ABC Lifting Engineers",
  "Abel Alarms",
  "A-Belco",
  "Ability Projects",
  "ABK Stratos Ventilation",
  "ABL Sursum",
  "Ablaze Building Solutions",
  "Able Roller Shutters",
  "ABS",
  "ABSI Technology",
  "Absolute Security",
  "AC & V",
  "AC Controls",
  "ACC Compressors",
  "Accel Lifts",
  "Accelerated Compost",
  "Accenta",
  "Access",
  "Acclaim",
  "Accord Lift Services",
  "Accoson",
  "Acctive",
  "ACDC Fans",
  "Ace Control Systems",
  "Ace Lifts",
  "Ace Midlands",
  "Ace Restaurant Equipment",
  "Ace Shutters",
  "Ace Sytems",
  "Ace Tech",
  "ACI Projects",
  "ACIS",
  "ACL Electrical",
  "ACME",
  "Acmex Doors",
  "Acorn",
  "Acorn Fire And Security",
  "Acorn Powell",
  "ACP Air Conditioning",
  "ACP Water Treatment",
  "Acrastyle",
  "Acrokool",
  "ACS",
  "Actaris",
  "Acteon",
  "Action Door Services",
  "Action Pumps",
  "Action Shutters",
  "Actionair",
  "Active Energy",
  "Active Power",
  "Active Security Group",
  "Actronic",
  "ACV",
  "AD Smith",
  "AD Sprinkler Protection",
  "Adalet",
  "Adam Kuhlerfabrik",
  "Adams Hydraulics",
  "Adams Rite",
  "Adamson Green & Co",
  "Adande",
  "Adastra",
  "Adcock",
  "Adcock & Shipley",
  "Adcrest",
  "Addicott Electrical",
  "Addvent",
  "ADE",
  "Adelphi Coldstream",
  "Ademco",
  "Adexsi UK",
  "Adford",
  "ADG Systems",
  "Adl Lift Services",
  "Adlor Uk",
  "Admiral",
  "Adrs Doors",
  "ADS",
  "ADT",
  "Advance Lifts",
  "Advanced",
  "Advanced Air",
  "Advanced Automated Access",
  "Advanced Detection Systems",
  "Advanced Diesel Engineering",
  "Advanced Doors",
  "Advanced Electrical Services (Yks)",
  "Advanced Ground Systems",
  "Advanced Handling",
  "Advanced Radiotech Corp",
  "Advanced Roller Doors",
  "Advanced Safety Communications",
  "Advanced Showers",
  "Advanced Technical Services",
  "Advancis Medical",
  "Advantage Controls",
  "Adventys",
  "A-E Air Handling Equipment",
  "AEC Power",
  "AED",
  "AEG",
  "Aegis Alarm Systems",
  "Aegis Water Treatment",
  "AEL Electrical",
  "Aeonmed",
  "Aercology Commercial",
  "Aermec",
  "Aermotor",
  "Aero Dock",
  "Aerocom",
  "Aeroflex",
  "Aeroflow",
  "Aeroform",
  "Aerostar",
  "Aertesi",
  "Aerzener Maschinenfabrik Gmbh",
  "AES Controls",
  "AESS",
  "AF Switchgear",
  "AF Technical",
  "AFA- Minerva",
  "AFE Serviceline",
  "Afinox",
  "Afos",
  "AFP Medical",
  "AFR Refrigeration",
  "AFS Systems",
  "AFT Gmbh",
  "AG Power Generation",
  "Aggora",
  "Aguilera Electronica",
  "AH",
  "AH Semstar",
  "AHB Services",
  "AHE",
  "Ahrend",
  "AHS",
  "Aidcall",
  "Aiphone",
  "AIR",
  "Air Handling Systems",
  "Air Ion Technology",
  "Air Liquide",
  "Air Plants",
  "Air Power Centre",
  "Air Products",
  "Air Receivers",
  "Air Science USA Llc",
  "Air Serv",
  "Air Solutions",
  "Air Tube Systems",
  "Air Tube Technologies",
  "Air Vent Technology",
  "AIRCO",
  "Aircraft Medical",
  "Airedale",
  "Airflow Instrumentat",
  "Airforce",
  "Airia Air Solutions",
  "Airmaster",
  "AirPower",
  "Airstream",
  "Airvent",
  "AIS Total Security",
  "AJ Products",
  "AK Glass & Glazing",
  "Alarmfast",
  "Alarmtronics",
  "Albany Doorsystems",
  "Albany Pumps",
  "Albert Waeschle",
  "Alberto Sassi",
  "Albion Water Heaters",
  "Alcon Laboratories",
  "Aldous & Stamp",
  "Alecto",
  "Alerton",
  "Alexander Controls",
  "Alfa Laval",
  "Algen Gilgen Door Systems",
  "All Around Heating",
  "All Pump Solutions",
  "Allair Fabrications",
  "Allan Aqua Systems",
  "Alldales",
  "Allen West Simple",
  "Allen-Bradley",
  "Alliance Door Engineering",
  "Alliance International",
  "Alliance Laundry Systems",
  "Allianz",
  "ALMiG",
  "Alpha Controls",
  "Alpha Fire Engineering",
  "Alpha Lifting Services",
  "Alphatec 1500",
  "Alternative Access",
  "Althin Medical",
  "Alto",
  "Altomed",
  "Altronix",
  "Amari",
  "Amazon",
  "Ambassador Lift Company",
  "AmbiRad",
  "Ambrex Switchgear",
  "Ambu",
  "Ameda",
  "Amenity Lighting",
  "American Orthodontic",
  "Ampac",
  "Ampcare Llc",
  "Ampetronic",
  "Amplivox",
  "AMPY",
  "Ampy Automations",
  "Ams Uk",
  "Amtec Medical",
  "Amtecs",
  "Analyticon Biotech",
  "Andec Fire Systems",
  "Andel",
  "Andover",
  "Andrews",
  "Andrews Sykes",
  "Andrews Water Heaters",
  "Andrews Weatherfoil",
  "Andross Electrics",
  "Anetic Aid",
  "Anmedic",
  "Anova Technology",
  "Anston Lifts",
  "Ansul",
  "Anthos Labtec Instru",
  "Antiference",
  "Antriebstechnik",
  "Antunes",
  "Anytronics",
  "AP Solutions",
  "APC",
  "Apex Lifts",
  "Apex Lighting Controls",
  "Apex Pumps",
  "API Fire And Safety",
  "APL",
  "APMG",
  "Apollo Lifts",
  "Apple",
  "Application Solutions",
  "Applied Energy Products",
  "Applied Power Engineering",
  "Approvedair",
  "Aqua",
  "Aqua Alarm",
  "Aqua Point",
  "Aqua Rio",
  "Aqua Sentry",
  "Aquaboss",
  "Aquafil",
  "AquAid",
  "Aqualeak",
  "Aqualibrium",
  "Aquamatic",
  "Aquamotion",
  "Aquasystem",
  "Aquatreat",
  "Aquatron",
  "Aquilant",
  "Aquilar",
  "AquiTron",
  "ARB",
  "Arco",
  "Arcomedical",
  "Arcotronics",
  "Arctic Chill",
  "Ariston",
  "Arizant Uk",
  "Arjo",
  "Arm",
  "Armashield",
  "Armitage Shanks",
  "Armsh",
  "Armstrong",
  "Armstrong Medical",
  "Arrow Valves",
  "Artemis Medical",
  "Arthrex Uk",
  "Artica",
  "Asbestos",
  "ASCO",
  "Asec Security",
  "Aspen Pumps",
  "Assa Abloy",
  "Astor Bannerman",
  "Astral Control Services",
  "Astralite",
  "Astrazeneca Uk",
  "Astroplast",
  "ATAG",
  "ATB",
  "ATC",
  "Athrodax Healthcare",
  "Atlantech",
  "Atlas Copco",
  "Atlas Security Doors",
  "ATP Electronics",
  "Audere",
  "Augustine Medical",
  "Aurora Lifts",
  "Automatic Systems",
  "Autoweigh Scales Uk",
  "Autron",
  "Avanos Medical Uk",
  "Avantco",
  "Avenue Alarms",
  "Avery Berkel",
  "Avigilon",
  "Axis",
  "Aztec",
  "B & D Electromedical",
  "B A Corry",
  "B Braun Medical",
  "B F Engineering",
  "B Meters",
  "Bahco",
  "Bailey",
  "Bailey Birkett",
  "Bailey Instruments",
  "Bain Marie",
  "Baker Ruskinn",
  "Bakersfield",
  "Baldor",
  "Baldwin Boxall",
  "Ballard",
  "Balmoral Tanks",
  "Balmoral Team",
  "Balticare",
  "Baltimore Aircoil",
  "Bambi",
  "Banco Ventilation",
  "Banico",
  "Bard",
  "Barduct Busbar",
  "Baric Pumps",
  "Barkell",
  "Barloworld",
  "Bartlett",
  "Bartrams",
  "Baumatic",
  "Bausch & Lomb Uk",
  "Baxi",
  "Baxter Healthcare",
  "Bayer Diagnostics",
  "BBC",
  "BBM Weston",
  "BCP Motors",
  "BeaconMedaes",
  "Beaver Healthcare",
  "Becker",
  "Beckman Coulter",
  "Becton Dickinson Uk",
  "Bedfont Scientific",
  "Beeline",
  "Beeston Heating",
  "Beko",
  "Belimo",
  "Bell & Gossett",
  "Bell Group",
  "Bellling",
  "Belmont",
  "Benchmark",
  "Bender",
  "Berchtold",
  "Berkley Controls",
  "Bernard Hastie",
  "Besam",
  "BGL",
  "Bib Ophthalmic",
  "Biddle",
  "Bi-Fold Rolfe",
  "Bill",
  "Bime",
  "Biomed Devices",
  "Biosense Medical",
  "Biotronik Uk",
  "Bioventus Llc",
  "Biral",
  "Birmingham Optical",
  "Bitzer Int",
  "B-K Medical",
  "Black Teknigas",
  "Blakley Electric",
  "BLE",
  "Blizzard",
  "Blue River",
  "BMM Weston",
  "BN Thermic",
  "BOC",
  "Bodyclock Healthcare",
  "Boehringer Ingelheim",
  "Boge",
  "Bolton Brady Industrial Doors",
  "Bonar Long",
  "Boon Edam",
  "Boothams",
  "Bora",
  "Bord & Overstrom",
  "Bosch",
  "Boss",
  "Boston Scientific",
  "Bosx",
  "Botley Cleansing",
  "Bower Electricals",
  "Bowers",
  "BPR Medical",
  "Bradbury",
  "Bradford-White",
  "Bradshaws",
  "Braithwaite",
  "Brandclad",
  "Brandon Medical Co",
  "Branemar Nobel Biocare",
  "Braun And Company",
  "Bravilor Bonamat",
  "Breathe Safety",
  "Breathevss",
  "Brewers",
  "Bridge Flue Systems",
  "Briggs",
  "Bristan",
  "Bristol Maid",
  "BRITA",
  "British Gas",
  "British Steriliser",
  "Broag",
  "Broen",
  "Bromwade",
  "Brook Crompton",
  "Brook Hansen",
  "Brook Motors",
  "Brooke Air",
  "Brooke Hansen",
  "Brooks",
  "Brother",
  "Bush",
  "Brymor",
  "BSA",
  "BSL",
  "BSS",
  "Buck & Hickman",
  "Build CT",
  "Building Automation",
  "Bulldog",
  "Bunn",
  "Burco",
  "Burkett",
  "Burlodge",
  "Burton Medical",
  "Burwell Mechanical Services",
  "Busch",
  "Bussmann",
  "Butterfly Network",
  "BVC Lamson",
  "BW Technologies",
  "BWS",
  "C F Thackray",
  "C J Medical",
  "Cableflow",
  "Calbarrie",
  "Calder Controls",
  "Calistra",
  "Calomax",
  "Calor Gas",
  "Calorex",
  "Cama",
  "CAME",
  "Camfil",
  "Candy",
  "Cane & Able",
  "Canham Controls",
  "Cannon",
  "Canon",
  "Canon Medical Systems",
  "Canonbury Products",
  "Cantel Medical",
  "Capcom",
  "Capital Water",
  "Caradon Stelrad",
  "Carbolite",
  "Cardiac Recorders",
  "Cardiac Services",
  "Cardinal Health",
  "Cardkey",
  "Carefusion Uk 235",
  "Caremed Alrick Healt",
  "Caresafe",
  "Carillion",
  "Carina Vt",
  "Carl Zeiss",
  "Carleton",
  "Carrier",
  "Carter Thermal Eng",
  "Cass",
  "Castellini Uk",
  "Castrol",
  "Caterlite",
  "CBC Security",
  "CBRE",
  "CCC",
  "CCL Veloduct",
  "CDS",
  "CE Electronics",
  "CED",
  "Cee Norm Uk",
  "CEF",
  "CEI Electrical",
  "Center",
  "Centerstore",
  "Centiel",
  "Central Medical",
  "Centrimaster",
  "Challis",
  "Chamberlain & Hookham",
  "Channel Safety Sys",
  "Charnwood Lifts",
  "Charter Kontron",
  "Chefs Range",
  "Chiltern Ivadex",
  "Chloride Bardic",
  "Chloride Industrial Bateries",
  "Chloride Power",
  "Choicemmed",
  "Chromis Uk",
  "Chubb",
  "Churches",
  "Churchesfire",
  "Ciat",
  "CIMM",
  "Circassia",
  "Circulating Pumps",
  "Cistermiser",
  "Citadel",
  "City Plumbing",
  "CJ Ringwood",
  "Clarke Controls",
  "Clarke Strongarm",
  "Clean Air",
  "Cleansing Service",
  "Clearview",
  "Clearwater",
  "Cleaver-Brooks",
  "Clement Clarke",
  "Clenaware",
  "Climate Cool",
  "Climaveneta",
  "Clinell",
  "Clipper",
  "Clyde Combustions",
  "CME Medical Uk",
  "CMI Healthcare Serv",
  "Coastal Cleaning",
  "Cobra",
  "Cochlea Europe",
  "Cochran",
  "Codelock",
  "Codemlon",
  "Coffing",
  "Colasit",
  "Collingwood",
  "Colman Moducel",
  "Colourfan",
  "Colt",
  "Colt International",
  "Coltrec",
  "ComfortAir",
  "Commander",
  "Commerical Washrooms",
  "Comp Air",
  "Conmed Uk",
  "Connaught Gas",
  "Connaught Water",
  "Constant Power Service",
  "Contacta",
  "Contactum",
  "Contained Air",
  "Cook Uk",
  "Cooks Blinds & Shutters",
  "Cookworks",
  "Cooleraid",
  "Coolmation",
  "Cooper Lighting",
  "Copeland",
  "Cordivari",
  "Corinthian Surgical",
  "Corning",
  "Corrigenda",
  "Cory Bros",
  "Cosmetal",
  "Cossiga",
  "Cotswold",
  "Courtney Pope",
  "Covidien",
  "CP Electronics",
  "CP Instruments",
  "CPC",
  "CPD",
  "CPE",
  "CPN",
  "CPS",
  "Crabtree",
  "Craig & Derricott",
  "Cram-A-lot",
  "Crawford Controls",
  "Creda",
  "Crest Medical",
  "Crestron",
  "Criticare Systems",
  "Critikon",
  "Croma",
  "Crompton",
  "Cromwell",
  "Crowcon",
  "Crypto Peerless",
  "CS Heat Transfer",
  "CSS Locksmiths",
  "C-TEC",
  "CTP Coil",
  "Cumberlidge",
  "Cummins Power Generation",
  "Curti Lifts",
  "Custom Coils",
  "Cutler Hammer",
  "Cygnus Uk",
  "D & H Partnership",
  "D B Orthodontics",
  "Daax",
  "Dab Pumps",
  "Daewoo Electronics",
  "Daikin",
  "Dalair",
  "Dale Power Solutions",
  "Dalkia",
  "Dan Dryer",
  "Danby Medical",
  "Danfoss",
  "Dantec Electronics",
  "Dantech",
  "Daray",
  "Darcy Products",
  "Dart Valley Systems",
  "Davidson & Co",
  "Dawson",
  "Dayton",
  "DDC Dolphin",
  "De Longhi",
  "De Smit Medical",
  "De Soutter Medical",
  "Deedlock",
  "Deep Sea Electronics",
  "Defensor",
  "Defibtech",
  "Delabie",
  "Dell Corporation",
  "Delmar Reynolds Med",
  "Delonghi",
  "Delta Control Systems",
  "Delta Design",
  "Delta Electrical Services",
  "Delta T",
  "Deltex Medical",
  "Demag",
  "Demeva",
  "Denco",
  "Denley",
  "Dennison",
  "Densa",
  "Designa",
  "Devilbiss",
  "Dewey Waters",
  "DGB Roofing",
  "DH Partnership",
  "Diagmed",
  "Diagnostic Sonar",
  "Diell",
  "Digitrace",
  "Digitron",
  "Dimplex",
  "Dion",
  "Direct Catering",
  "Direct Healthcare",
  "Discount Glass",
  "Discovery",
  "DiSYS Technologies",
  "DiTEC",
  "Divelife",
  "Diversitech",
  "Dixell",
  "Dixey Instruments",
  "Dixon",
  "Docusign",
  "Dolphin",
  "Dometic",
  "Domnick Hunter",
  "Don Whitely Scientif",
  "Doorgear",
  "Doosan",
  "Dorc Uk",
  "Dorma",
  "Dormakaba",
  "Dorman Smith",
  "Douglas",
  "Dowdings",
  "Downs Surgical",
  "DP Medical Systems",
  "DQM",
  "Draeger",
  "Drain Doctor",
  "Draper",
  "Drayton Controls",
  "Drayton Tanks",
  "Dresser Meters & Instruments",
  "Drive Devilbiss",
  "Druck",
  "Dry Flow",
  "DTE",
  "Dunford",
  "Dunham Bush",
  "Duomo",
  "Durafan",
  "Duraflow",
  "Durasteel",
  "Durham Switchgear",
  "Durr Dental",
  "Durrance",
  "Dutypoint",
  "Dynex Technologies",
  "Dyno-Rod",
  "Dysis Medical",
  "Dyson",
  "Dywer",
  "E A Engineering",
  "E M S",
  "E&R Moffat",
  "EAC",
  "Early Birds Fire Protection",
  "East Healthcare",
  "Eastron",
  "Eaton",
  "Eazyzap",
  "Ebara",
  "ECA Services",
  "ECC",
  "ECC Moulded Breakers",
  "Eclipse Interacoust",
  "Ecodan",
  "Ecolab",
  "Economic Insulations",
  "Ecosmart",
  "Ectron",
  "Eden Medical",
  "Eden Springs",
  "EDF",
  "Edge Medical",
  "EDMI",
  "Edwards Lifesciences",
  "Egerton Hospital",
  "EIS",
  "Elbi",
  "ELC",
  "Elco",
  "Electra",
  "Electranet",
  "Electro Controls",
  "Electrolux",
  "Electromek",
  "Elektrogas",
  "Elga",
  "ELGI",
  "Elite Fire",
  "Elkay",
  "Elro",
  "Elster",
  "Elta Fans",
  "Eltherm",
  "Elucian",
  "EM Entrematic",
  "Emergi Lite",
  "Emerson",
  "Emlite",
  "Emmeti",
  "Emo",
  "Empower",
  "EMS",
  "Endomag",
  "Endress & Hauser",
  "Energix",
  "Energy Ict",
  "Eng Electric",
  "Engart Fans",
  "Englands",
  "Englands Aerials",
  "English Electric",
  "Enigma",
  "Enpress Llc",
  "Entera Medical",
  "Entryphone",
  "Envair",
  "Envirochem",
  "Envirocure",
  "Envirotech Alarms",
  "Envirovent",
  "Enwa",
  "EO",
  "EOGB",
  "E-Or",
  "Eppendorf",
  "Epress Lifts",
  "Epsilon",
  "Epsom",
  "Erbe Medical Uk",
  "Eric",
  "Ericsson",
  "Eriks",
  "Esam",
  "Esaote Europe Bv",
  "ESBE",
  "Esc Power & Controls",
  "Esch Trace Heating",
  "Eschmann",
  "ESPA Pumps",
  "ESTS (Gb)",
  "Eta",
  "Etac",
  "Euro Surgical",
  "Eurocoils",
  "Europa",
  "Europe Components",
  "European Water Care",
  "Euro-Plast",
  "Europump",
  "Eurotherm/Chessell",
  "Evac+Chair",
  "Evans Lifts",
  "Evolt",
  "Evolution",
  "Evoqua",
  "Excel",
  "Excelsior Lifts",
  "Exide",
  "Exitguard",
  "ExitMaster",
  "F P",
  "FAAC",
  "FAAST",
  "Fabricated Products",
  "FAFS",
  "Fairways",
  "Falcon",
  "Faraday",
  "Farnell",
  "Fast Park",
  "FDR",
  "Federal Electric",
  "Felcon",
  "Felcon/Goldsworth",
  "Fellowes",
  "Fergusson Palin",
  "Ferno Uk",
  "Ferraris Medical",
  "Ferroli",
  "Ferrups",
  "FFB",
  "FG Wilson",
  "Fike",
  "Fileder Filter Systems",
  "Finning",
  "Fire Chief",
  "Firemark",
  "FireSAFE",
  "Fischach",
  "Fisher & Paykel",
  "Fisher Scientific",
  "FläktGroup",
  "Flakt woods",
  "Flamco",
  "Flamefast",
  "Flexmort",
  "Flomasta",
  "Floton",
  "Flow Mech Products",
  "Flowcool",
  "Fluid Automation",
  "Fluke",
  "Flygt Pumps",
  "Fogtec Fire Protection",
  "Foris",
  "Formlabs Inc",
  "Fosse",
  "Foster",
  "FPS",
  "Franks",
  "Freeston",
  "Frese",
  "Fresenius",
  "Fresenius Kabi",
  "Freshflo",
  "Frie",
  "Friedrich Grohe",
  "Friga Bohn",
  "Frigidaire",
  "Frontier Pitts",
  "Frostech",
  "Fuji",
  "Fujitsu",
  "Fukuda Denshi Uk",
  "Full Support Group",
  "Fullbourn Medical",
  "Furmanite",
  "Furness Control",
  "Fusebox",
  "Futura",
  "Future Flooring",
  "G & J Logistics",
  "G E Clinical Service",
  "G E Healthcare",
  "G E Medical Systems",
  "G N Otometrics",
  "G N Resound",
  "G T Vision",
  "G&T Doors",
  "G4S",
  "Galc Cooling Serv",
  "Galderma",
  "Galekem Solutions",
  "Gamak",
  "Gardner Denver",
  "Gas Arc Group",
  "Gasforce",
  "Gastoline",
  "GE Healthcare",
  "GE Power Controls",
  "GE Water",
  "GEA Searle",
  "Gebhardt Vent",
  "GEC",
  "Gec Alsthom",
  "Gemco",
  "Gemini",
  "General Electric",
  "Genesys Medical Solutions",
  "Genie",
  "Gent",
  "Getinge",
  "Geze",
  "Giesse",
  "Gilbert",
  "Gilgen Door Systems",
  "Gilkes Pumps",
  "Glamox Luxo",
  "Gledhill",
  "Gliderol Garage Doors",
  "Global Water",
  "Glow-worm",
  "GMS Thermal Products",
  "GN Otometrics Uk",
  "Gojo",
  "Goldseal Valves",
  "Goodwood Metalcraft",
  "Gorbel",
  "Goulds Pumps",
  "Grafton Optical Co",
  "Gram",
  "Grant",
  "Grant Haze",
  "Grason Stadler",
  "Great Lakes Air",
  "Green Brook",
  "Greenham",
  "Greenheck",
  "Greenwood",
  "Grohe",
  "Grox",
  "Grundfos",
  "GS",
  "GT Doors",
  "GTC",
  "G-Tec",
  "G-Tekt Europe Manufa",
  "Guardian",
  "Guidant",
  "Guideline",
  "Guldmann",
  "Gunnebo",
  "Guymark Uk",
  "Gyrus Medical",
  "H C Slingsby Plc",
  "H&K",
  "H20",
  "Haag-Streit Uk",
  "Hac",
  "Hackbridge & Hewittic",
  "Haes Technologies",
  "Hager",
  "Haier",
  "Haigh",
  "Hall & Kay",
  "Hallmark Fire Systems",
  "Halls Fire Protection",
  "Halstead",
  "Halycon",
  "Hammonds",
  "Hamworthy",
  "Hanaul",
  "Handicare",
  "Hardware Solutions",
  "Harlech Industrial Doors",
  "Harley Blinds",
  "Harrier",
  "Hart & Cooley",
  "Hart Door Systems",
  "Hartley & Sudgen",
  "Hartzell",
  "Hastings HVAC",
  "Hattersley",
  "Havells",
  "Hawco",
  "Hawker",
  "Hawksley & Sons",
  "Hayward Air",
  "Health Tec",
  "Healthcare 21 Uk",
  "Heat Transfer",
  "Heatcraft",
  "Heatherose",
  "Heatrae Sadia",
  "Heatstore",
  "Heidelberg Engineer",
  "Heine",
  "Helios",
  "Hemco",
  "Hemocue",
  "Henderson Door Systems",
  "Henderson-Bostwick",
  "Henleys Medical",
  "Henry Schein",
  "Heraeus",
  "Hettich",
  "Hewlett Packard",
  "High Voltage Design and Build",
  "Hikvision",
  "Hillrom",
  "Hill-Rom Medaes",
  "Hiross",
  "Hisense",
  "Hitachi",
  "Hitec Power Protection",
  "HME",
  "Hobart",
  "Hochiki European",
  "Holden & Brooke",
  "Holland Heating",
  "Hologic Uk",
  "Homecraft Rolyan",
  "Honeywell",
  "Hooper Construction",
  "Hoover",
  "Horizon",
  "Horizon Lifts",
  "Hormann",
  "Horne",
  "Horstmann",
  "Horton",
  "Hoshizaki",
  "Hospira",
  "Hospital Lamp Supplies",
  "Hospital Metalcraft",
  "Hotpoint",
  "Hoval",
  "How Engineering",
  "Howarth",
  "Howden",
  "Howorth Air Technolo",
  "HPA",
  "HRP",
  "HRS",
  "HSS Hire",
  "Hubdic",
  "Human Med AG",
  "Humeca",
  "Huntleigh",
  "Huntleigh Akron",
  "Huntleigh Diagnostics",
  "Huntleigh Nesbit Evans",
  "HVAC Control Systems",
  "Hybec",
  "Hyco",
  "Hydramist",
  "Hydrax",
  "Hydro Cleaning",
  "Hydro Mag",
  "Hydro Sense Water Detection",
  "Hydroflow",
  "Hydromag",
  "Hydrotec",
  "Hydrotech",
  "Hydrovane",
  "Hydrovern",
  "HypaClens",
  "Hyrdro Clean",
  "Hyropath",
  "Hythe Marine",
  "IME Repair Service",
  "Iberital",
  "Ice-A-Cool",
  "Icel",
  "Ice-O-Matic",
  "ICS",
  "ICS Cool Energy",
  "IDE",
  "Ideal",
  "Ideal Heating",
  "Idrotuba",
  "Iflo Engineering",
  "Igenix",
  "Iiyama",
  "IMI",
  "IMI Air Conditioning",
  "IMP Pumps",
  "Indesit",
  "Indo Lighting",
  "Industrial Air Conditioning",
  "Industrial Devices",
  "Industrial Door Engineering",
  "Industrial Elec",
  "Ingersoll Rand",
  "Inmar",
  "Insect-O-Cuter",
  "Inspiration Health",
  "Instanta",
  "Instrumentation Lab",
  "Inta",
  "InTandem Systems",
  "Integra Neuroscience",
  "Integrated Control",
  "Integrated Security",
  "Intercall",
  "Interlevin",
  "Intermedical Uk",
  "Invacare Uk",
  "Invensys",
  "Invertek",
  "iPad",
  "iRed",
  "Iridex Corporation",
  "Isis Medical",
  "Iskra",
  "Isopharm",
  "iTron",
  "ITT",
  "IVAC",
  "IWE",
  "IWS",
  "J&E Hall",
  "J&J Services",
  "J.D Fire",
  "J.S. Air Curtains",
  "Jackson",
  "Jacob White Hospital",
  "Javelin Controls",
  "Jazz",
  "JB Meiklejohn",
  "Jeavons",
  "Jet Range",
  "JetSet",
  "Jewel Saffire",
  "Jewson",
  "JJ Electronic Comp",
  "JLA",
  "Joerns Healthcare",
  "John Bradshaw",
  "John Deere",
  "John Moore",
  "Johnson",
  "Johnson & Johnson",
  "Johnson Controls",
  "Johnson Tech",
  "Joule",
  "Joventa",
  "JP Solutions",
  "Jun Air",
  "June Medical Uk",
  "Jupiter-Spartan",
  "JVC",
  "JWS Water",
  "K & D Beare Roofing",
  "K & H Medical",
  "Kaba Door Systems",
  "Kamstrup",
  "Kane-May",
  "Kapitex Healthcare",
  "Karl Storz",
  "Karomed",
  "Karser",
  "KCI Medical",
  "Kebomed Uk",
  "Kee Guard",
  "Keeler",
  "Keeprite",
  "Keighley Lifts",
  "Kelvin",
  "Kent",
  "Kentec",
  "Kenwood",
  "Keraflo",
  "Kestral",
  "Kettler",
  "Key Elevators",
  "Keyguard",
  "KG Metalcraft",
  "KGN Pillinger",
  "Kheiley",
  "Kiasu",
  "Kidde",
  "Kinetic Electronics",
  "Kingfisher",
  "Kirton",
  "Klargester",
  "Klockner Moeller",
  "KLS Martin",
  "Knight Imaging",
  "Knightsbridge",
  "Knowlton & Newman",
  "Kobe",
  "Kohler",
  "Kone",
  "Kontron Instruments",
  "Koronka",
  "Kotterman",
  "Kowa Optimed Europe",
  "Kraus & Naimer",
  "Kreuzer",
  "Kubtec Medical",
  "Kutzner + Weber",
  "L.M. Straughan",
  "Labcaire",
  "Labcold",
  "Laborie Medical Tech",
  "Lacy - Hulbert",
  "Laerdal Medical",
  "Lamona",
  "Lancer",
  "Landis+Gyr",
  "Landon Kingsway",
  "Lanes",
  "Langford Electronics",
  "Lasermet",
  "Latchway",
  "Lavazza",
  "Leaderflush",
  "LEC",
  "LEC+",
  "Legrand",
  "Leica",
  "Lennox",
  "Leroy-Somer",
  "Lester Control Systems",
  "LEV",
  "Levante",
  "Lewden",
  "LG",
  "Libra Medical",
  "Lidco",
  "Liebert",
  "Liebherr",
  "Liftec",
  "Liftmaster",
  "Light Crystal",
  "Liko Uk",
  "Likorrall",
  "Limbco",
  "Limbs & Things",
  "Lina Medical Uk",
  "Lincat",
  "Lindrick",
  "Linet Uk",
  "Linvatec",
  "Lion Laboratories",
  "Litechnica",
  "Liteoptics",
  "Lloyds",
  "Lochinvar",
  "Lodestar",
  "LOF",
  "Logan Carpets",
  "Lohenner Gmbh & Co.",
  "London Fan Company",
  "Long & Crawford",
  "Lowara",
  "LST Projects",
  "LTE",
  "Lubron",
  "Lucy Zodion",
  "Lumenis",
  "L'unite Hermetique",
  "Luo",
  "Lux Traffic Control",
  "LV Power Solutions",
  "LV8",
  "LVE",
  "Lynd Products",
  "Lyndhurst",
  "M C Drilling",
  "M Homer",
  "M&G",
  "Maam",
  "Machine Mart",
  "Maestro",
  "Maestrowave",
  "Magnaclean",
  "Magnetic Autocontrol",
  "MagVent",
  "MAHA",
  "Maico",
  "Maidaid",
  "Mainline Instruments",
  "Mainline Optical",
  "Maintaining Environm",
  "Malem Medical",
  "Mallard Euroair",
  "Man Europ",
  "Manguard",
  "Maniero",
  "Manitowoc",
  "Manrose",
  "Mansfield Cryogenics",
  "Maplin Environmental",
  "Maquet",
  "Marathon Electric",
  "Margen Medical",
  "Mark Taulbut",
  "Marquette Electronic",
  "Marsden Weighing",
  "Martindale",
  "Masimo Uk",
  "Massey Colbeck",
  "Mat",
  "Mather & Platt",
  "Matrix Control Solutions",
  "Matthew Hall",
  "Matthews and Yates",
  "Max-Pak",
  "Mayday",
  "Mazzer",
  "MB Locks",
  "MBO Sales ( Uk).",
  "MCE Scotland",
  "MCG Switchgear",
  "McQuay",
  "ME",
  "MEC",
  "Med & Ind M",
  "Med Air Tech",
  "Medaes",
  "Medcare Treatment",
  "Medela Uk",
  "Medfit Uk",
  "Medi Plinth",
  "Medical Education",
  "Medical Gas Pipeline",
  "Medicare",
  "Medicare Services",
  "Medifa GmbH & Co",
  "Medimotion",
  "Mediplan",
  "Mediquip",
  "Medisave Uk",
  "Mediscus Products",
  "Meditech",
  "Meditron Anaesthetic",
  "Medline",
  "Medstor",
  "Medstrom",
  "Medtronic",
  "Megger",
  "Mellor Bromley",
  "Melyd Medical",
  "MEM",
  "Mennekes",
  "Mentor Medical",
  "Menvier",
  "Mercian Surgical",
  "Meridian Doors",
  "Meridian Lifts",
  "Merlin",
  "Merlin Gerin",
  "Merrychef",
  "Mersen",
  "Meterology",
  "Metrix",
  "Metro",
  "Meynell",
  "MGC Diagnostics",
  "MGP",
  "MGPS Services",
  "MHS Boilers",
  "Micro Medical",
  "Microlife",
  "Micromat",
  "Microtech",
  "Microvitec",
  "Midcon Systems",
  "Midland Transformers",
  "Miele",
  "Mikrofill",
  "Millenium Medical",
  "Millenium",
  "Millipore",
  "MIM",
  "MIM Medical",
  "Mindray",
  "Minerva",
  "Minerva Dental",
  "Minimax",
  "Mira",
  "Mitie",
  "Mitsubishi",
  "Mitsubishi Electric",
  "Mitsubishi Heavy Industries",
  "Mizuho",
  "MK",
  "ML Carpets & Floori",
  "MMM",
  "MMPL",
  "Mobilis",
  "Mobrey",
  "Modine",
  "Moducel",
  "Modular Heating Systems",
  "Moffat",
  "Molift",
  "Monmouth Scientific",
  "Monsoon",
  "Moretti",
  "Morgan Fire",
  "Morphy Richards",
  "Morris Vermaport",
  "Motivair Compressors",
  "Motorola",
  "Mountjoy",
  "Moyne Roberts",
  "MPGS",
  "MPS",
  "MR Electrical",
  "MRI (Planet)",
  "MSM",
  "MTA Dry Energy",
  "MTS Spa Italy",
  "Musgrave",
  "Myenergi",
  "Mylek",
  "Myson",
  "N H Eastwood & Son",
  "N&C",
  "Nabic",
  "Nationwide",
  "Natus Uk",
  "NBC Environment",
  "ND Metering Solutions",
  "NDS",
  "Neatafan",
  "Nebraska",
  "Nederman",
  "Neen Healthcare",
  "Nellcor (Uk).",
  "Nelson Tansley",
  "Nenutec",
  "Neomed Uk",
  "Neptune",
  "Nergeco",
  "Nespresso",
  "Netgear",
  "New Air",
  "Newark Copper Cylinders",
  "Newey & Eyre",
  "Newgate (Newark)",
  "Newlec",
  "NFC",
  "NGS",
  "Nidd Valley Medical",
  "Nife",
  "Niftylift",
  "Niglon",
  "Nihon Kohden (Uk)Ltd",
  "Nikon",
  "Nisbets",
  "NJ Froment",
  "Nocchi",
  "Nomeq",
  "Nordairniche",
  "Nordic Medical",
  "Northvale",
  "Nouvag",
  "Nova Lift Co",
  "Novar",
  "Novatek",
  "NPBI UK",
  "NRS Healthcare",
  "NuAire",
  "Numac",
  "Nussbaum",
  "Nutricia",
  "NVC",
  "Oakland Elevators",
  "Oberg",
  "Ocura Healthcare",
  "Ohmeda",
  "Olimpia Splendid",
  "Olympus",
  "Omega",
  "Omega Laser Systems",
  "Omnipod",
  "Omron Healthcare",
  "OpeMed",
  "OPTI",
  "Optident",
  "Options Medical",
  "Optivision",
  "Optos Plc",
  "Orca",
  "Ormandy Rycroft",
  "Ortho Europe",
  "Orthosonics",
  "Osborne Refrigeration",
  "OSO",
  "Osteotec",
  "OTIS",
  "Otodynamics",
  "Ottermill",
  "Oxford Instruments",
  "Pacetech",
  "Palco Laboratories",
  "Palcon Systems",
  "Palintest",
  "Pallard",
  "Pammenter & Petrie",
  "Panasonic",
  "Parasense",
  "Pari Medical",
  "Parker",
  "Parker Bath",
  "Parker Hannifin",
  "Parkersell",
  "Parkside Healthcare",
  "Partners For Endosco",
  "Passivent",
  "Pastorkalt",
  "Patterson Medical",
  "Paxman Coolers",
  "Paxton",
  "PCL",
  "Pegasus",
  "Pegasus Airwave",
  "Pegler",
  "Pelco",
  "Penlon",
  "Penn",
  "Pennamed",
  "Pentair",
  "Pentax Uk",
  "Performance Health",
  "Perkin Elmer",
  "Perkins",
  "Petbow",
  "PFG Water Storage",
  "Pharmed Uk",
  "Philips Healthcare",
  "Philips Medical",
  "Philips Respironics",
  "Phillips",
  "Phoenix Healthcare",
  "PHS",
  "Physical State",
  "Physio Control Uk",
  "Physiomed Services",
  "Physique Training",
  "Pickering Lifts Europe",
  "Pipe Scenes",
  "Pipe Solutions",
  "Pipeline",
  "Pirtek",
  "PJW",
  "PKS",
  "Plastic Construction",
  "Plastica",
  "Platform Lift Company",
  "Plessey",
  "Plinth Company",
  "Plinth Medical",
  "Plumb Centre",
  "Plumbstop",
  "PM Luft",
  "PME",
  "PMP",
  "PMS Pumps",
  "Pneumate",
  "Polar",
  "Polycom",
  "Portal",
  "Porter Nash Medical",
  "Portsmouth Surgical",
  "Potterton",
  "Power Capacitors",
  "Power Electronics",
  "Power Products",
  "Power Systems International",
  "Power Tecnique",
  "Powermag",
  "Powermaster",
  "PoWoGaz",
  "Powrmatic",
  "Precisa",
  "Precision",
  "Premex",
  "Premier Fire Security",
  "Premiere Healthcare",
  "Pressalit",
  "Pressmain",
  "Pressuess-Air",
  "Prestige Fire Protection",
  "PRI Elite",
  "Primary Water",
  "Prime Switchgear",
  "Primeline",
  "Prism",
  "Pro Drainage",
  "Proact Medical",
  "Prodrainag",
  "Pro-Economy",
  "Pro-Elec",
  "Profile Lighting",
  "Progress Cleaning",
  "Projects",
  "Promedics",
  "Protec",
  "Proteus",
  "Proton",
  "PSA",
  "Ptex",
  "PTS",
  "PTSG",
  "Pullen Pumps",
  "Pulmolink",
  "Pulpmatic",
  "Puma",
  "Pump Practitioners",
  "Pumpseal",
  "Pusen",
  "PWS",
  "Pycko Scientific",
  "Q Medical Tech",
  "Qados",
  "Qed Scientific",
  "Quartz Heating Systems",
  "Quay Flooring",
  "Qube",
  "Quickdry",
  "Quinshield",
  "Quooker",
  "Rada",
  "Raffo",
  "Range Boilers",
  "Rangemaster",
  "Rank Stanley Cox",
  "Rapidor",
  "Rational",
  "Ray O Vac",
  "Rayburn",
  "Raychem",
  "Rayleigh Instruments",
  "Raynor",
  "RB Medical Engineer",
  "Reactive Doors",
  "Reavey",
  "Record",
  "Redline",
  "Rednal Pneumatics",
  "Redring",
  "Reel",
  "Reflex",
  "Regal",
  "Rehau",
  "Reliance",
  "Remco",
  "Remeha",
  "Rentokil",
  "Resmed",
  "Revenco",
  "Reyrolle",
  "Reznor",
  "RGL",
  "RH Davey",
  "RH Morton",
  "Richard C Stonehouse",
  "Richard Knight",
  "Richard Wolf UK",
  "Ricoh",
  "Ridgegear",
  "Ridon",
  "Riello",
  "Riester",
  "Rietschle Thomas",
  "Rimmer Bros",
  "Rite-Hite",
  "Rittal Rudolf Loh GmbH & Co",
  "RJ Electrical",
  "RJC",
  "RMC",
  "Robert Prowting",
  "Robey Wellman",
  "Robin",
  "Robus",
  "Roche Diagnostics",
  "Rocket Of London",
  "Roco",
  "Rodi",
  "Rolec Services",
  "Romec",
  "Roof Units Group",
  "Rooftech",
  "Rotary",
  "Rother Engineering",
  "Royston",
  "RPS",
  "RS Components",
  "RSH Estates Stores",
  "RTC",
  "Ruck",
  "Rurbofan",
  "Russell Hobbs",
  "Ryco",
  "Rycroft",
  "Ryefield",
  "Rytec",
  "S&S Northern",
  "Sabre",
  "Safe Aid",
  "Safe Edge",
  "Safegard Systems",
  "Safelab",
  "Safetell",
  "Safety Kleen",
  "Safety Showers",
  "SafetyMax",
  "Salicru",
  "Salter-Weigh Tronix",
  "Sammic",
  "Samson Controls",
  "Samsung",
  "Sangamo",
  "Saniflo",
  "Santon",
  "Sanyo",
  "Sapphire Controls",
  "Sara",
  "Saracen",
  "Sarel",
  "Sarena",
  "Sartorius",
  "Satchwell",
  "Sauter",
  "Saxon Lifts",
  "SBS",
  "Scame",
  "Schindler",
  "Schlumberger",
  "Schneider",
  "Schneider Electric",
  "Schuco International",
  "Scotsman",
  "Scott",
  "Scott Mcarthur",
  "Scott Safety",
  "SCS",
  "SD&P",
  "SDMO",
  "SDS Protection",
  "SE Controls",
  "Seagraves",
  "Searle",
  "Seaward",
  "Seaward Medical",
  "Sebia",
  "SEC",
  "SEC Lighting",
  "Seca",
  "Secure Options",
  "Security Access Systems",
  "Security Control System",
  "Security Services Group",
  "Security Solutions",
  "Seepex UK",
  "Seers Medical",
  "See-Tech",
  "Seitron",
  "Select Switchgear",
  "Selwood Pumps",
  "Sense Medical",
  "Sensors Uk",
  "Sensus",
  "Sentinel Doors",
  "Sentry",
  "SEP",
  "Serenga",
  "SES",
  "SES Controls",
  "Severn Controls",
  "Sevron",
  "SFA",
  "SGH Estates Stores",
  "Shapemaster Global",
  "Sharp",
  "Sheffmed Trade",
  "Sherwood Medical",
  "Shield",
  "Shire Controls",
  "Shirley Glass",
  "Shorrock",
  "Si Pressurements",
  "Siemens",
  "Siemens Water",
  "Sigmacon",
  "SigTEL",
  "Silvent",
  "Silver Airline",
  "Simai Medical",
  "Simcare",
  "Simeon Medical",
  "Simmtronic Lighting Controls",
  "Simple",
  "Simplex",
  "Sirrus",
  "Sissons",
  "Sjk Scientific",
  "Skillbond Direct",
  "Skyframe",
  "Skyjacks",
  "Slater",
  "SLC",
  "SLE",
  "Slingsby",
  "SM",
  "SMA Solar Technology",
  "Smart Medical",
  "Smedegaard",
  "Smith & Nephew",
  "Smiths Medical",
  "Socomec",
  "Software House",
  "Sola-Boost",
  "Solaredge",
  "SolaX Power",
  "Solent Bearings",
  "Solent Blinds",
  "Solid State",
  "Solis",
  "Sonesta",
  "Sonosite",
  "Sontex",
  "Sony",
  "Sony Centre",
  "Sound Byte Solutions",
  "South Wales Switchgear",
  "Southampton Glass",
  "Southern Electricity Board",
  "Southern Health",
  "Southern Redfern",
  "Southern Scientific",
  "Southern Services",
  "SP Services",
  "Space Air Conditioning",
  "Spacelabs Medical",
  "Spacie",
  "Spartan Controls",
  "SPC",
  "Spear and Jackson",
  "Specialist Alarm Services",
  "Specialized Door Services",
  "Spectrolab",
  "Spectronic Campsec",
  "Spectrum Ophthalmics",
  "Sperian | Honeywell",
  "Spinnaker Flooring",
  "Spirax Sarco",
  "Spirotech",
  "SPM Instruments",
  "Sportshall",
  "SPP Pumps",
  "Square D",
  "SS Electrical",
  "SSE",
  "SSH",
  "St Jude Medical Uk",
  "Stadium",
  "Staefa Control Systems",
  "Stanbridge",
  "Stangingley Pharma",
  "Stanley",
  "Stannah",
  "Star Refrigeration",
  "Starkstrom",
  "Static Systems",
  "STD Pharmaceutical",
  "Stelrad",
  "Sterex Electrolysis",
  "Sterilab",
  "Steris",
  "Sterling",
  "Stertil",
  "STI",
  "Stiebel Eltron",
  "Stihler Electronic",
  "Stokvis",
  "Stowood Scientific",
  "Strand Lighting",
  "Stratos",
  "Strebel",
  "Strocco",
  "Stryker Uk",
  "Stuart",
  "Suez",
  "Sulzer",
  "Summit Medical",
  "Sunflower Medical",
  "Sunrise Medical",
  "Sunvic",
  "Supply Chain",
  "Support Systems Int",
  "Surgical Designs",
  "Suzler",
  "Swarco",
  "Swegon",
  "Swisslog",
  "Switchgear Services",
  "SWS",
  "SWY Fire & Rescue",
  "Sychem",
  "Sykes Pumps",
  "Symmetry",
  "Synectics Medical",
  "Systemair",
  "Syston Doors",
  "TFM",
  "T&S Architectural",
  "TAC",
  "Tae Evo",
  "TAG",
  "Talley Group",
  "Tamlite",
  "Taulbut",
  "Taylors Magna",
  "TClarke",
  "TEC",
  "Technical Gas",
  "Tecnik",
  "Teco",
  "Telemecanique",
  "TEM Elesta",
  "Tempest",
  "Temple Lifts",
  "Tenacore",
  "Tenscare",
  "Termini",
  "Tersano",
  "Tesla Transformers",
  "Testo",
  "Testomat",
  "TEV",
  "Texecom",
  "TGC",
  "Thames Valley Pumps",
  "The Alarm Company",
  "The Drain Epert",
  "The Electric Gate Co",
  "The Express Lift Company",
  "The Good Birth Co",
  "The Gritting Company",
  "The Helping Hand Company",
  "Therapy Equipment",
  "Thermal Solutions",
  "Thermo Fisher",
  "Thermo Shandon",
  "Thermoscreen",
  "Thermotek",
  "Thorlux Lighting",
  "Thorn",
  "ThyssenKrupp",
  "Time",
  "Timeplan",
  "Timesco",
  "Tipo",
  "Titan",
  "TLV",
  "TNG Conuslting Engineers",
  "Tom Hall",
  "Topcon",
  "Topspec Euro",
  "Tormax",
  "Toshiba",
  "Toshiba Medical",
  "Total Refrigeration",
  "TPT",
  "Trace Heating",
  "Trane",
  "Transmitton",
  "Tranter",
  "Treatment 4 Water",
  "Trend Control Systems",
  "Tricity Bendix",
  "Tricool",
  "Tridac Dental Equip",
  "Trident",
  "Trinity Fire & Security Systems",
  "Triple Red",
  "Tristel",
  "Triton",
  "Truesense",
  "Truflo Air Movement",
  "TRUMPF",
  "TSI Instruments",
  "TSML",
  "T-Squared",
  "TTS",
  "Turner",
  "Twyford",
  "Twyver Switchgear",
  "Tyco",
  "Tynetec",
  "Tyrework",
  "U C",
  "UCS",
  "UEL",
  "UGI Meters",
  "UHS",
  "UK Cylinders",
  "Ultramedic",
  "Ultrawave",
  "Unicat",
  "Unico",
  "Uniflair",
  "Uniline",
  "Uninteruptable Power Supplies",
  "UNOX",
  "UOS",
  "USystems",
  "Vacon",
  "Vador",
  "Vaillant",
  "Valera",
  "Valina",
  "Valleylab Uk",
  "Valtrar",
  "Van Remmen",
  "Vapac",
  "Varem",
  "Vela Medical",
  "Vent-Axia",
  "Veolia",
  "Verathon Medical",
  "Vernacare",
  "Vernatech",
  "Vertiv",
  "VES",
  "VES Andover",
  "VForce",
  "Viamed",
  "Viasys Healthcare",
  "Viatom Technology",
  "Vickers",
  "Vickers Medical",
  "Vickroy Fire Tech",
  "Victor",
  "Vidacare BV",
  "Videx Security",
  "Viessmann",
  "Viking Direct",
  "Viking Pumps",
  "Vimec",
  "Vision Medical",
  "Vital Signs",
  "Vitalograph",
  "Vodafone",
  "Vokes Unipak",
  "Vortice",
  "Vox Ignis",
  "Voyager",
  "Vulcan Tanks",
  "VWR",
  "W & H Uk",
  "Wade",
  "Wadkin",
  "Wadkin Ultracare",
  "Wakeling Medical",
  "Walchem",
  "Waldron Office",
  "Walker Filtration",
  "Walker Fire",
  "Walker Macleod",
  "Walpac",
  "Walsall",
  "Walters Medical",
  "Wandsworth",
  "Wardall Engineering",
  "Wardray",
  "Warner Howard Group",
  "Warwick-Evans Optic",
  "Water Main",
  "Waterking",
  "Waterlogic",
  "Waterside Fab",
  "Wayne Dalton",
  "WB Power Services",
  "WCS",
  "Weather-Rite",
  "Wedeco Uv Systems",
  "WEG",
  "Weger",
  "Weightron Bilanciai",
  "Weir Pumps",
  "Weire",
  "Welch Allyn",
  "Wellman",
  "Werfen",
  "WES",
  "Wesse",
  "Wessex",
  "Western Automation",
  "Westmade",
  "WF",
  "Whirpool",
  "Whiste Structures",
  "White Medical",
  "White Structures",
  "Wiere",
  "Wight Crystal",
  "Wilkinsons",
  "Will & James",
  "Williams",
  "Williams Medical",
  "Wilo",
  "Wilts",
  "Winchcomb",
  "Winder",
  "Window Master",
  "Winterhalter",
  "Winx",
  "Wolf Salamander",
  "Woods",
  "Worcester",
  "Worcester Bosch",
  "World Dryer",
  "World Heat",
  "Worldwide",
  "Wormald",
  "Wright",
  "WS Rothband",
  "WSM",
  "Wyko",
  "Wyle",
  "Wylex",
  "Xlerator",
  "Xpelair",
  "Xpert It Services",
  "Xtralis",
  "Yale",
  "Yamasu Uk",
  "Yardman",
  "York",
  "York/Johnson",
  "Yorkshire Care Equip",
  "Yorkshire Switchgear",
  "Zanussi",
  "Zepher",
  "Ziehl-Abegg",
  "Zilmet",
  "Zimmer",
  "Zip",
  "Ziton",
  "Zucchini",
  "Zymary",
];

export const manufacturers = manufacturerList.map((manufacturer) => {
  return {
    label: manufacturer,
    code: manufacturer,
  };
});
